<template>
    <v-dialog
        v-model="dialog"
        persistent
        eager
        :max-width="displayWidth"
        @keydown.esc="onEscapeKeydown"
    >
        <v-card>
            <v-card-text class="pr-2 pb-1 d-flex flex-direction-row">
                <div class="pr-2">
                    <div class="py-3 text-h6">
                        {{ title }}
                    </div>
                    <div class="text-subtitle-1 mb-3">
                        {{ message }}
                    </div>
                    <a v-if="details.length" @click="onShowDetailsClick">
                        {{ showDetailsText }}
                    </a>
                    <div class="details-section mt-3 pl-2">
                        <div
                            v-for="(item, index) in displayDetails"
                            :key="`detail-${index}`"
                        >
                            <span>{{ item }}</span>
                        </div>
                    </div>
                </div>
                <div v-show="options.showIcon" :style="iconStyle"></div>
            </v-card-text>
            <v-card-actions class="justify-end">
                <v-btn small outlined @click="onCancelClick">{{
                    options.cancelActionText
                }}</v-btn>
                <v-btn small color="primary" @click="onConfirmClick">{{
                    options.confirmActionText
                }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { randomElement } from '@/common/helpers';

export default {
    name: 'OopsDialog',
    data() {
        return {
            images: [
                'animal-3296309_640.png',
                'cat-2669554_640.png',
                'dog-2438803_640.png',
                'hippopotamus-2780699_640.png',
                'iguana-2427495_640.png',
                'isolated-2253166_640.png',
                'prima-donna-3760983_640.png',
                'penguins-4618323_640.png',
                'turkey-2361883_640.png',
                'frog-1445824_640.png'
            ],
            selectedImage: '',
            dialog: false,
            resolve: null,
            reject: null,
            title: 'Oops!',
            message: 'Sorry, something went wrong.',
            showDetails: false,
            details: [],
            options: {
                confirmActionText: 'Confirm',
                cancelActionText: 'Cancel',
                width: '500',
                height: '300',
                showIcon: true
            }
        };
    },
    computed: {
        showDetailsText() {
            if (this.showDetails) {
                return 'Click here to hide the details...';
            }
            return 'Click here to see the details...';
        },
        displayDetails() {
            if (this.showDetails) {
                return [...this.details];
            }
            return [];
        },
        displayImage() {
            return `/img/errors/${this.selectedImage}`;
        },
        iconStyle() {
            return {
                backgroundImage: `url(${this.displayImage})`,
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                minHeight: '250px',
                flex: '1 1 250px'
            };
        },
        displayWidth() {
            if (this.$vuetify.breakpoint.smAndDown) {
                return '90%';
            }
            return this.options.width;
        }
    },
    watch: {
        dialog(value) {
            if (value === true) {
                this.showDetails = false;
                this.suffleImage();
            }
        }
    },
    mounted() {
        this.suffleImage();
    },
    methods: {
        open(title, message, details, options) {
            this.dialog = true;
            this.title = title || this.title;
            this.message = message || this.message;
            this.details = details;
            this.options = { ...this.options, ...options };
            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        onCancelClick() {
            this.resolve(false);
            this.dialog = false;
        },
        onConfirmClick() {
            this.resolve(true);
            this.dialog = false;
        },
        onShowDetailsClick() {
            this.showDetails = !this.showDetails;
        },
        onEscapeKeydown() {
            this.onCancelClick();
        },
        suffleImage(index) {
            if (index >= 0) {
                this.selectedImage = this.images[index];
            } else {
                const lastImage = `${this.selectedImage}`;
                this.selectedImage = randomElement(this.images);
                while (
                    lastImage.toLowerCase() === this.selectedImage.toLowerCase()
                ) {
                    this.selectedImage = randomElement(this.images);
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.details-section {
    overflow: auto;
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    height: 120px;
}
</style>
